/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Identical_OrigInputs */

const en_landing_drift_identical_orig = /** @type {(inputs: Landing_Drift_Identical_OrigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`identical to the original`)
};

const zh_landing_drift_identical_orig = /** @type {(inputs: Landing_Drift_Identical_OrigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与原图完全一致`)
};

/**
* | output |
* | --- |
* | "identical to the original" |
*
* @param {Landing_Drift_Identical_OrigInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_identical_orig = /** @type {((inputs?: Landing_Drift_Identical_OrigInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Identical_OrigInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_identical_orig(inputs)
	return zh_landing_drift_identical_orig(inputs)
});
export { landing_drift_identical_orig as "landing.drift.identical_orig" }